<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="stage2_Subsidy"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'District',
		'Block',
		'Village',
		'AppID',
		'farmerName',
		'Adm_Amount',
		'farmer_Mobile',
		'Approval_Date',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'STAGE2_SUBSIDY_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}
                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                    <p-sortIcon field="Block"></p-sortIcon>
                </th>
                <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                    <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                    <p-sortIcon field="Village"></p-sortIcon>
                </th>
                <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                    <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                    <p-sortIcon field="AppID"></p-sortIcon>
                </th>
                <th pSortableColumn="farmerName">{{'FARMER_NAME'| translate}}
                    <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                    <p-sortIcon field="farmerName"></p-sortIcon>
                </th>
                <th pSortableColumn="Adm_Amount">{{'ADM_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="Adm_Amount" display="menu"></p-columnFilter>
                    <p-sortIcon field="Adm_Amount"></p-sortIcon>
                </th>
                <th pSortableColumn="farmer_Mobile">{{'FARMER_MOBILE'| translate}}
                    <p-columnFilter type="text" field="farmer_Mobile" display="menu"></p-columnFilter>
                    <p-sortIcon field="farmer_Mobile"></p-sortIcon>
                </th>
                <th pSortableColumn="Approval_Date">{{'APPROVAL_DATE'| translate}}
                    <p-columnFilter type="text" field="Approval_Date" display="menu"></p-columnFilter>
                    <p-sortIcon field="Approval_Date"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-stage2_Subsidy>
            <tr>
                <td>{{stage2_Subsidy.District}}</td>
                <td>{{stage2_Subsidy.Block}}</td>
                <td>{{stage2_Subsidy.Village}}</td>
                <td>{{stage2_Subsidy.AppID}}</td>
                <td>{{stage2_Subsidy.farmerName}}</td>
                <td>{{stage2_Subsidy.Adm_Amount}}</td>
                <td>{{stage2_Subsidy.farmer_Mobile}}</td>
                <td>{{stage2_Subsidy.Approval_Date}}</td>
                
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>